import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { ProjectDetail } from "@shared/schema";

export default function ExportView({ project }: { project: ProjectDetail }) {
  const hasMedia = project.scenes.some((s) => s.currentImageGenId || s.currentVideoGenId);
  const build = useMutation({ mutationFn: () => api.exportProject(project.id) });

  return (
    <div className="grid" style={{ gridTemplateColumns: "1fr", gap: 16 }}>
      <div className="card pad">
        <h2>Експорт-пакет для дизайнера</h2>
        <div className="hint" style={{ marginBottom: 12 }}>
          ZIP із покадровим брифом (00_BRIEF.md), перші кадри, відео, timing sheet і бренд-чеклист — як у tz_kidden_designer.
        </div>
        <ul style={{ color: "var(--muted)", fontSize: 13, lineHeight: 1.8, marginTop: 0 }}>
          <li>00_BRIEF.md — людиночитний бриф (парність з еталоном)</li>
          <li>brief.json — машиночитний (проєкт + сцени + промпти)</li>
          <li>frames/ — перші кадри (9:16) · videos/ — кліпи (Kling)</li>
          <li>app_screens/ — специфікації UI-екранів (Figma/AE)</li>
          <li>timing_sheet.csv · prompts/</li>
        </ul>

        <button className="btn primary" disabled={build.isPending} onClick={() => build.mutate()}>
          {build.isPending ? <span className="spinner" /> : hasMedia ? "Зібрати пакет (ZIP)" : "Зібрати пакет (бриф без медіа)"}
        </button>

        {build.isError && (
          <div className="hint" style={{ color: "var(--red)", marginTop: 10 }}>
            {(build.error as Error).message}
          </div>
        )}
        {build.data?.downloadUrl && (
          <div style={{ marginTop: 14 }}>
            <a className="btn accent" href={build.data.downloadUrl} download>
              ⤓ Завантажити ZIP
            </a>
            <div className="hint" style={{ marginTop: 6 }}>Лінк дійсний 1 годину.</div>
          </div>
        )}
        {!hasMedia && (
          <div className="hint" style={{ marginTop: 10 }}>
            Медіа ще не згенеровано — пакет міститиме бриф, сценарій і промпти (без кадрів/відео).
          </div>
        )}
      </div>
    </div>
  );
}
